import React, { useRef, useEffect } from "react";
import { Button } from "react-bootstrap";

interface Props {
  onChange: (dataUrl: string) => void;
}

export default function SignaturePad({ onChange }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const isDrawing = useRef(false);

  useEffect(() => {
    const canvas = canvasRef.current!;
    canvas.width = canvas.offsetWidth;
    canvas.height = 200; // altura fija o dinámica
    const ctx = canvas.getContext("2d")!;
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000";
  }, []);

  const getCoordinates = (e: React.MouseEvent | React.TouchEvent) => {
    const canvas = canvasRef.current!;
    const rect = canvas.getBoundingClientRect();
    let clientX: number, clientY: number;

    if ("touches" in e) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }

    return { x: clientX - rect.left, y: clientY - rect.top };
  };

  const startDrawing = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault(); // 👈 evita scroll
    const ctx = canvasRef.current!.getContext("2d")!;
    const { x, y } = getCoordinates(e);
    isDrawing.current = true;
    ctx.beginPath(); // 👈 inicia un nuevo trazo
    ctx.moveTo(x, y);
  };

  const draw = (e: React.MouseEvent | React.TouchEvent) => {
    if (!isDrawing.current) return;
    e.preventDefault(); // 👈 evita scroll mientras dibujas
    const ctx = canvasRef.current!.getContext("2d")!;
    const { x, y } = getCoordinates(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const endDrawing = (e?: React.MouseEvent | React.TouchEvent) => {
    if (!isDrawing.current) return;
    isDrawing.current = false;
    e?.preventDefault(); // 👈 evita scroll mientras dibujas
    const ctx = canvasRef.current!.getContext("2d")!;
    ctx.closePath(); // 👈 cierra el trazo actual
    const canvas = canvasRef.current!;
    onChange(canvas.toDataURL("image/png"));
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current!;
    const ctx = canvas.getContext("2d")!;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    onChange("");
  };

  return (
    <div>
      <canvas
  ref={canvasRef}
  style={{ border: "1px solid #ccc", width: "100%", height: "200px", touchAction: "none" }}
  onMouseDown={startDrawing}
  onMouseMove={draw}
  onMouseUp={endDrawing}
  onMouseLeave={endDrawing}
  onTouchStart={startDrawing}
  onTouchMove={draw}
  onTouchEnd={endDrawing}
/>
      <Button variant="secondary" className="mt-2" onClick={clearCanvas}>
        Limpiar
      </Button>
    </div>
  );
}